import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { BrowserLocationService } from '../services/browser-location.service';

@Injectable({
    providedIn: 'root'
})
export class BackbuttonGuard  {

    constructor(private browserLocationService: BrowserLocationService) {
    }

    public canDeactivate(component: boolean,
                         currentRoute: ActivatedRouteSnapshot,
                         currentState: RouterStateSnapshot,
                         nextState?: RouterStateSnapshot)
        : boolean {

        if (this.browserLocationService.backClicked) {
            // Reset backClicked state.
            this.browserLocationService.backClicked = false;
            // Reset browser href to current.
            history.pushState(null, null, location.href);
            // Components can subscribe to the PopEvent to handle back button themselves.
            this.browserLocationService.setPopSubject(false);
            // Stop backButton routing event.
            return false;
        }
        return true;
    }

}
